<template>
<div class="chart-container">
  <canvas ref="chart"></canvas>
</div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'PiChart',

  data () {
    return {
    }
  },

//  props: [ 'data', 'colors', 'labels'],

  methods: {
    img () {
      return this.$refs.chart.toDataURL('image/png')
    },

    update (data, colors, labels) {
      let v = this
//      let colors = ['#641e16', '#d35400', '#117a65', '#1b4f72', '#4a235a', '#273746', '#707b7c', '#f4d03f', '#73c6b6', '#5499c7']
//      let colors = v.colors

      if ('piChart' in v) {
        v.piChart.data.datasets.forEach(dataset => { dataset.data = data })
        v.piChart.data.lables = labels
        v.piChart.update()
        console.log('Update chart...')
      } else {
        v.piChart = new Chart(v.$refs.chart, {
          type: 'doughnut',
          data: {
            datasets: [{
              data: data,
              backgroundColor: colors
            }],

            labels: labels
          },
          options: {
            responsive: true,
            legend: {
              position: 'top'
            }
          }
        })
        console.log('Initialize chart...')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";


</style>
